import { gql } from "@apollo/client";
import { AccountFragment } from "fragments/account";
import { KeyFragment } from "fragments/key";


export const get = gql`
  query KeyGet($domain: String!, $keyId: String!) {
    viewer {
      id
      account {
        id
        ...AccountFragment
        domains {
          id
          get(domain: $domain){
            id
           
                keys {
                  id
                  get (keyId: $keyId) {
                    ...KeyFragment
                  }
               
            }
          }
        }
      }
    }
  }
  ${AccountFragment}
  ${KeyFragment}
`;


export const list = gql`
  query KeyList($domain: String!, $input: ListInput) {
    viewer {
      id
      account {
        id
        domains {
          id
          get(domain: $domain){
            id
            
                keys {
                  id
                  list(input: $input) {
                    id
                    last
                    items {
                      ...KeyFragment
                    }
                
              }
            }
          }
        }
      }
    }
  }
  ${KeyFragment}
`;



export const create = gql`
  mutation KeyNew($domain: String!, $input: KeyInputCreate!) {
    viewer {
      account {
        domains {
          get(domain: $domain){
         
                keys {
                  create(input: $input) {
                    keySecret
                    ...KeyFragment
                  }
              
            }
          }
        }
      }
    }
  }
  ${KeyFragment}
`;



export const remove = gql`
  mutation KeyRemove($domain: String!, $keyId: String!) {
    viewer {
      account {
        domains {
          get(domain: $domain){
          
                keys {
                  get(keyId: $keyId) {
                    remove
                  }
              
            }
          }
        }
      }
    }
  }
`;


export const update = ({ domain }) => (cache) => {
  Object.keys(cache.data.data).forEach((key) => {
    if (key.includes(`${domain}/queries`)) {
      cache.data.delete(key);
    }
  });
};
